import React, { useState } from "react";

// Images
// import qrImg from "../images/qr-example.png";

// Antd
import { Skeleton } from "antd";

import Pill from "./Pill";

// Icon
// import { ReloadOutlined } from "@ant-design/icons";

const emptyData = "-";

function TableInfo({ userData }) {
  // Start Image loading
  const [isImgLoaded, setIsImgLoaded] = useState(false);
  const [isImgError, setIsImgError] = useState(false);

  const handleImageLoad = () => {
    setIsImgLoaded(true);
    setIsImgError(false);
  };

  const handleImageError = () => {
    setIsImgLoaded(false);
    setIsImgError(true);
  };

  return (
    <div className="flex flex-col j-c-center a-i-center gap-15 m-b-25">
      <img
        src={userData?.qr_url}
        alt="qr"
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{ display: isImgLoaded ? "block" : "none" }}
      />
      {isImgError && <p>Error loading image.</p>}
      {!isImgLoaded && !isImgError && (
        <div className="bg-white p-10">
          <Skeleton.Avatar
            loading={true}
            active
            size={311}
            shape={"square"}
            // style={{ marginTop: "15px" }}
          />
        </div>
      )}

      {/* <p>A4B242E5T</p> */}

      <h3>{userData?.name}</h3>

      <Pill
        btnStyle={
          userData?.status === "attended"
            ? "bg-success border-green text-green"
            : "bg-error border-error text-error"
        }
      >
        {(!userData || userData?.status === "registered") && "Not Checked-In"}
        {userData?.status === "attended" && "Checked-In"}
      </Pill>

      {/* <Button className="text-white" type="text">
        <ReloadOutlined className="m-r-5" />
        Refresh
      </Button> */}

      <Pill btnStyle="bg-red text-white">
        Table Number : {userData?.table_no ?? emptyData}
      </Pill>

      <Pill btnStyle="bg-red text-white">
        Seat Number : {userData?.seat_no ?? emptyData}
      </Pill>

      <Pill btnStyle="bg-red text-white">
        Lucky Number : {userData?.lucky_no ?? emptyData}
      </Pill>

      <p className="fs-12">*Please show this QR code for Check-In Purposes</p>
    </div>
  );
}

export default TableInfo;
